import type { McpEnvelopeErrorCode, McpToolName } from '../contracts/mcp';

/** Nazwy narzędzi MCP dla ludzi (Ustawienia → Claude (MCP), wybór narzędzi runu, audyt). */
export const MCP_TOOL_LABELS: Record<McpToolName, string> = {
  search_clients: 'Szukaj klientów',
  get_client_context: 'Kontekst klienta',
  list_tasks: 'Lista zadań',
  create_task: 'Utwórz zadanie',
  propose_task_update: 'Zmień zadanie',
  log_time: 'Zapisz czas',
  list_time_entries: 'Wpisy czasu',
  draft_email: 'Szkic maila',
  propose_send_email: 'Poproś o wysyłkę maila',
  search_knowledge: 'Szukaj w Wiedzy',
  propose_memory_update: 'Zaproponuj zmianę pamięci',
  create_agent_run: 'Zarejestruj przebieg agenta',
  append_run_event: 'Dopisz zdarzenie przebiegu',
  complete_agent_run: 'Zakończ przebieg agenta',
  list_agent_runs: 'Zlecenia dla Claude',
  get_agent_run: 'Szczegóły zlecenia',
  list_assets: 'Zasoby utrzymania',
  get_approval_status: 'Stan akceptacji',
  // Fala 10: codzienna praca przez MCP
  get_client: 'Karta klienta',
  create_client: 'Dodaj klienta',
  update_client: 'Zmień klienta',
  propose_client_archive: 'Zaproponuj archiwizację klienta',
  add_contact: 'Dodaj kontakt',
  update_contact: 'Zmień kontakt',
  list_projects: 'Lista projektów',
  get_project: 'Szczegóły projektu',
  create_project: 'Utwórz projekt',
  update_task: 'Zmień zadanie (wprost)',
  add_task_comment: 'Komentarz do zadania',
  list_meetings: 'Spotkania',
  create_meeting: 'Dodaj spotkanie',
  add_meeting_notes: 'Notatki i transkrypcja spotkania',
  add_client_note: 'Notatka o kliencie',
  list_client_notes: 'Notatki o kliencie',
  list_client_documents: 'Dokumenty klienta',
  // 17.10.2026: szybkie notatki (karteczki na „Dziś”)
  list_quick_notes: 'Szybkie notatki',
  add_quick_note: 'Dodaj szybką notatkę',
  update_quick_note: 'Zmień szybką notatkę',
  complete_quick_note: 'Odhacz szybką notatkę',
  get_client_history: 'Historia klienta',
  list_threads: 'Wątki poczty',
  get_thread: 'Wątek poczty',
  draft_reply: 'Szkic odpowiedzi',
  get_today: 'Dziś',
  list_pending_approvals: 'Czekające akceptacje',
  update_time_entry: 'Popraw wpis czasu',
  add_knowledge_note: 'Dodaj do Wiedzy',
  list_offers: 'Oferty',
  get_offer: 'Oferta',
  get_asset: 'Zasób utrzymania',
  add_monitor: 'Włącz monitoring',
  list_incidents: 'Incydenty',
  get_incident: 'Incydent',
  // Fala 12 (pełny MCP): klienci, projekty, zadania, czas
  update_client_links: 'Odnośniki klienta',
  set_client_owner: 'Zmień opiekuna klienta',
  restore_client: 'Przywróć klienta',
  set_primary_contact: 'Kontakt główny',
  archive_contact: 'Archiwizuj kontakt',
  restore_contact: 'Przywróć kontakt',
  refresh_client_registry: 'Dane firmy z rejestru',
  update_project: 'Zmień projekt',
  archive_project: 'Archiwizuj projekt',
  restore_project: 'Przywróć projekt',
  add_project_person: 'Dodaj osobę do projektu',
  remove_project_person: 'Usuń osobę z projektu',
  set_project_partner_rate: 'Stawka partnera w projekcie',
  move_task: 'Przenieś zadanie',
  update_task_checklist: 'Checklista zadania',
  archive_task: 'Archiwizuj zadanie',
  restore_task: 'Przywróć zadanie',
  archive_time_entry: 'Archiwizuj wpis czasu',
  restore_time_entry: 'Przywróć wpis czasu',
  // Fala 12: Utrzymanie, usługi, monitoring strony
  get_asset_setup: 'Zasób do edycji',
  list_services: 'Usługi i umowy',
  get_service: 'Usługa',
  create_asset: 'Dodaj zasób',
  update_asset: 'Zmień zasób',
  archive_asset: 'Archiwizuj zasób',
  add_asset_component: 'Dodaj element zasobu',
  update_asset_component: 'Zmień element zasobu',
  add_supplier_cost: 'Dodaj koszt dostawcy',
  update_supplier_cost: 'Zmień koszt dostawcy',
  archive_supplier_cost: 'Archiwizuj koszt dostawcy',
  mark_supplier_renewed: 'Odnowione u dostawcy',
  generate_renewal_payment: 'Wygeneruj płatność z umowy',
  add_reminder_rule: 'Dodaj przypomnienie',
  update_reminder_rule: 'Zmień przypomnienie',
  create_service: 'Dodaj usługę',
  update_service: 'Zmień usługę',
  archive_service: 'Archiwizuj usługę',
  update_monitor: 'Zmień monitoring strony',
  archive_monitor: 'Wyłącz monitoring strony',
  check_monitor_now: 'Sprawdź teraz',
  // Fala 12: oferty, Rozliczenia, Wiedza, spotkania, poczta
  create_offer: 'Nowa oferta',
  update_offer_draft: 'Zmień szkic oferty',
  new_offer_version: 'Nowa wersja oferty',
  submit_offer_to_owner: 'Przekaż ofertę właścicielowi',
  return_offer_to_draft: 'Oferta do poprawy',
  mark_offer_outcome: 'Odpowiedź klienta na ofertę',
  propose_send_offer: 'Zaproponuj wysyłkę oferty',
  list_billing_drafts: 'Zestawienia rozliczeniowe',
  create_billing_draft: 'Nowe zestawienie',
  create_billing_draft_from_payment: 'Zestawienie z płatności cyklicznej',
  add_billing_entries: 'Dodaj wpisy do zestawienia',
  remove_billing_entries: 'Usuń wpisy z zestawienia',
  add_billing_line: 'Pozycja stała w zestawieniu',
  remove_billing_line: 'Usuń pozycję zestawienia',
  update_billing_draft: 'Zmień zestawienie',
  submit_billing_draft: 'Zestawienie do akceptacji',
  reopen_billing_draft: 'Zestawienie do edycji',
  cancel_billing_draft: 'Anuluj zestawienie',
  propose_billing_paid: 'Zaproponuj oznaczenie opłacenia',
  get_knowledge_note: 'Notatka z Wiedzy',
  update_knowledge_note: 'Zmień notatkę w Wiedzy',
  archive_knowledge_note: 'Archiwizuj notatkę',
  restore_knowledge_note: 'Przywróć notatkę',
  restore_knowledge_version: 'Przywróć wersję notatki',
  update_meeting: 'Zmień spotkanie',
  archive_meeting: 'Archiwizuj spotkanie',
  restore_meeting: 'Przywróć spotkanie',
  decide_meeting_task_proposals: 'Propozycje zadań ze spotkania',
  decide_meeting_decisions: 'Ustalenia ze spotkania',
  assign_thread: 'Przypisz wątek do klienta',
  create_task_from_message: 'Zadanie z wiadomości',
  update_email_draft: 'Zmień szkic maila',
  cancel_email_draft: 'Anuluj szkic maila',
};

export const MCP_ERROR_CODE_LABELS: Record<McpEnvelopeErrorCode, string> = {
  VALIDATION_ERROR: 'Nieprawidłowe dane',
  FORBIDDEN: 'Brak uprawnień',
  NOT_FOUND: 'Nie znaleziono (albo poza zakresem tokenu)',
  APPROVAL_REQUIRED: 'Wymaga akceptacji',
  CONFLICT: 'Konflikt (dane zmieniły się albo klucz użyty ponownie)',
  RATE_LIMITED: 'Za dużo żądań',
  INTEGRATION_UNAVAILABLE: 'Integracja niedostępna',
  UNAUTHENTICATED: 'Nieprawidłowy albo nieaktywny token',
  INTERNAL: 'Błąd serwera',
};
